import { KpiMetrics } from "./KpiMetrics";
import { usePermissions } from "@/hooks/usePermissions";

const KPIManagement = () => {
  const { hasPermission } = usePermissions();

  return <>{hasPermission("kpi_management_read") && <KpiMetrics />}</>;
};

export { KPIManagement };
